import * as React from 'react'
import './LatestLink.scss'
import { ActionType, linkInfoType, reducerStoreType } from "../../reducers/types";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import noDataIcon from '../../images/null_icon.svg';
import { injectIntl, IntlShape } from "react-intl";
import Button from '@material-ui/core/Button';
import { toast } from "react-toastify";
import { globalIntl } from "../App/App";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  currency: string,
  linkInfo: linkInfoType,
  intl: IntlShape
}

class LatestLink extends React.Component<IProps> {

  handleCopy = (window: any) => {
    var copyDOM: any = document.getElementById("linkText")
    console.log(copyDOM)
    var range = document.createRange(); //创建一个range
    window.getSelection().removeAllRanges();   //清楚页面中已有的selection
    range.selectNode(copyDOM);    // 选中需要复制的节点    
    window.getSelection().addRange(range);   // 执行选中元素
    var successful = document.execCommand('copy');    // 执行 copy 操作  
    // 移除选中的元素  
    if (successful) {
      toast.success(globalIntl.formatMessage({ id: 'copySuccess' }))
    } else {
      toast.error(globalIntl.formatMessage({ id: 'copyError' }))
    }
    window.getSelection().removeAllRanges();
  }

  public render() {

    let { intl, linkInfo } = this.props
    return (
      <Grid item xs={12} md={6} lg={7} xl={8}>
        <div className="LatestOrders">
          <div className="header">
            <div className="headerLeft">
              <h2>{intl.formatMessage({ id: 'collectionLink' })}</h2>
            </div>
            <a href="/#/app/searchLink" className="seeMore">{intl.formatMessage({ id: 'more' })}</a>
          </div>
          <div className="container">
            {this.props.linkInfo.payLink === "" ?
              <div className="noData">
                <img src={noDataIcon} alt="no data" />
                <p>{intl.formatMessage({ id: 'noData' })}</p>
              </div> :
              <div className="linkBox">
                <Grid container>
                  <Grid item xl={11}>
                    <div className="link" id="linkText">
                      {linkInfo.payLink}
                    </div>
                  </Grid>
                  <Grid item xl={1}><Button color="primary" onClick={() => { this.handleCopy(window) }}>{intl.formatMessage({ id: 'copy' })}</Button></Grid>
                </Grid>
              </div>}
          </div>
        </div>
      </Grid>);
  }
}

export default injectIntl(connect((state: reducerStoreType, props) => {
  return {
    currency: state.app.userInfo ? state.app.userInfo.currency : '',
    linkInfo: state.createLink.linkInfo
  }
})(LatestLink))